/************************* Async Content *************************/

export const getPageContentHtml = async (pageUrl) => {
  try {
    // Get page as JSON to get body_html, to inject in modal/ drawer
    const pageJson = await await fetch(pageUrl + ".json").then((res) => res.json());
    if (pageUrl.includes("policies/")) {
      return pageJson.policy.body;
    } else {
      return pageJson.page.body_html;
    }
  } catch (error) {
    console.error("Error: ", error);
    return "";
  }
};

export const getSectionHtml = async (section, canonicalUrl) => {
  try {
    let url = window.location.pathname + "/?sections=" + section;
    if (canonicalUrl) {
      url = new URL(canonicalUrl).pathname + "/?sections=" + section;
    }

    // Get page as JSON to get body_html, to inject in modal/ drawer
    const sectionJson = await await fetch(url).then((res) => res.json());
    return sectionJson[section];
  } catch (error) {
    console.error("Error: ", error);
    return "";
  }
};

export const getTemplateHtml = async (templateId) => {
  const template = document.getElementById(templateId);
  return template.innerHTML;
};

/************************* Trap Focus *************************/

let gtcPreviousFocus = null;

export const gtcSetPreviousFocus = (element) => {
  if (element) {
    gtcPreviousFocus = element;
  } else {
    gtcPreviousFocus = document.activeElement;
  }
};

function gtcHandleTrapFocus(e) {
  const isTabPressed = e.key === "Tab" || e.keyCode === 9;

  if (!isTabPressed) {
    return;
  }

  if (e.shiftKey) {
    // if shift key pressed for shift + tab combination
    if (document.activeElement === this.firstFocusableElement) {
      this.lastFocusableElement.focus(); // add focus for the last focusable element
      e.preventDefault();
    }
  } else {
    // if tab key is pressed
    if (document.activeElement === this.lastFocusableElement) {
      // if focused has reached to last focusable element then focus first focusable element after pressing tab
      this.firstFocusableElement.focus(); // add focus for the first focusable element
      e.preventDefault();
    }
  }
}

export const gtcTrapFocus = (element) => {
  const focusableElements = element.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );

  element.firstFocusableElement = focusableElements[0];
  element.lastFocusableElement = focusableElements[focusableElements.length - 1];

  // Focus the first element initially
  element.firstFocusableElement.focus();

  // Listen for and trap the keyboard
  element.addEventListener("keydown", gtcHandleTrapFocus);
};

export const gtcRemoveTrapFocus = (element) => {
  // Remove the event listener
  element.removeEventListener("keydown", gtcHandleTrapFocus);

  if (gtcPreviousFocus) {
    gtcPreviousFocus.focus();
    gtcPreviousFocus = null;
  }
};

/************************* Scrolllock *************************/

export const gtcScrollLock = (classArr) => {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.body.style.paddingRight = scrollbarWidth + "px";
  document.body.style.overflow = "hidden";
  document.body.classList.add(...classArr);
};

export const gtcScrollUnlock = (classArr) => {
  document.body.style.paddingRight = "";
  document.body.style.overflow = "";
  document.body.classList.remove(...classArr);
};

/************************* Debounce *************************/

/**
 *
 * @param {*} func The function to call after the delay
 * @param {*} delay The delay in milliseconds before calling the function
 * @returns  A function that will call the provided function after the delay
 */
export const gtcDebounce = (func, delay = 300) => {
  let debounceTimer;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
};
